export const locationsGroup = [
  [
    "Mussoorie, Uttarakhand",
    "Nainital, Uttarakhand",
    "Rishikesh, Uttarakhand",
    "Haridwar, Uttarakhand",
    "Chakrata, Uttarakhand",
    "Kedarnath, Uttarakhand",
    "Harsil, Uttarakhand",
    "Kausani, Uttarakhand",
    "Almora, Uttarakhand",
    "Nanda Devi, Uttarakhand",
  ],
  [
    "Shimla, Himachal Pradesh",
    "Kullu, Himachal Pradesh",
    "Manali, Himachal Pradesh",
    "Solang Valley, Himachal Pradesh",
    "Rahatang Pass, Himachal Pradesh",
    "Dharamsala, Himachal Pradesh",
    "Dalhousie, Himachal Pradesh",
    "Kasauli, Himachal Pradesh",
    "Bir-Billing, Himachal Pradesh",
    "Parashar Lake, Himachal Pradesh",
    "Kangra, Himachal Pradesh",
  ],
  [
    "Amarnath, Jammu & Kashmir",
    "Srinagar, Jammu & Kashmir",
    "Gulmarg, Jammu & Kashmir",
    "Katra, Jammu & Kashmir",
    "Sonmarg, Jammu & Kashmir",
    "Pahalgam, Jammu & Kashmir",
    "Doda, Jammu & Kashmir",
    "Dal Lake, Jammu & Kashmir",
  ],
  [
    "Nubhra Valley, Ladakh",
    "Tanglang La, Ladakh",
    "Magnetic Hill, Ladakh",
    "Markha Valley, Ladakh",
  ],
  [
    "Amritsar, Punjab",
    "Pathankot, Punjab",
    "Chandigarh, Punjab",
    "Wagah Border, Punjab",
    "Patiala, Punjab",
    "Mohali, Punjab",
    "Kapurthala, Punjab",
    "Bhatinda, Punjab",
    "Jalandhar, Punjab",
  ],
  [
    "Red Fort, Delhi",
    "Jama Masjid, Delhi",
    "Chandni Chowk, Delhi",
    "Akshardham, Delhi",
    "Qutab Minar, Delhi",
    "Lotus Temple , Delhi",
    "India Gate, Delhi",
    "Rashtrapati Bhavan, Delhi",
    "Raj Ghat, Delhi",
  ],
  [
    "Kurukshetra, Haryana",
    "Panchkula, Haryana",
    "Ambala, Haryana",
    "Karnal, Haryana",
    "Panipat, Haryana",
    "Kalesar National Park, Haryana",
  ],
  [
    "Puri, Orissa",
    "Konark, Orissa",
    "Bhubaneswar, Orissa",
    "Sambalpur, Orissa",
    "Balasore, Orissa",
  ],
  [
    "Netarhat, Jharkhand",
    "Deoghar, Jharkhand",
    "Daltonganj, Jharkhand",
    "Hazaribagh, Jharkhand",
    "Patratu Valley, Jharkhand",
    "Ranchi, Jharkhand",
  ],
  [
    "Patna, Bihar",
    "Nalanda, Bihar",
    "Bodh Gaya, Bihar",
    "Rajgir, Bihar",
    "Begusarai, Bihar",
  ],
  [
    "Ayodhya, UP",
    "Agra, UP",
    "Mathura, UP",
    "Vrindavan, UP",
    "Prayagraj, UP",
    "Lucknow, UP",
    "Varanasi, UP",
    "Kanpur, UP",
    "Jhansi, UP",
  ],
  [
    "Jaipur, Rajasthan",
    "Udaipur, Rajasthan",
    "Jaisalmer, Rajasthan",
    "Jodhpur, Rajasthan",
    "Bikaner, Rajasthan",
    "Ranthambore, Rajasthan",
    "Pushkar, Rajasthan",
    "Mount Abu, Rajasthan",
    "Ajmer, Rajasthan",
    "Chittorgarh, Rajasthan",
    "Alwar, Rajasthan",
    "Kota, Rajasthan",
    "Bhangarh, Rajasthan",
    "Aravali Hills, Rajasthan",
  ],
  [
    "Ahmedabad, Gujarat",
    "Kutch, Gujarat",
    "Gir, Gujarat",
    "Somnath, Gujarat",
    "Statue of unity, Gujarat",
    "Dwarka, Gujarat",
    "Daman & Diu, Gujarat",
    "Surat, Gujarat",
    "Dandi  Beach, Gujarat",
    "Ratanmahal Sloth Bear  Sanctuary, Gujarat",
  ],
  [
    "Ajanta & Ellora Caves, Maharashtra",
    "Mahabaleshwar, Maharashtra",
    "Shirdi, Maharashtra",
    "Lonavala, Maharashtra",
    "Nashik, Maharashtra",
    "Pune, Maharashtra",
    "Bhimashankar, Maharashtra",
    "Ratnagiri, Maharashtra",
    "Khandala, Maharashtra",
    "Nagpur, Maharashtra",
    "Solapur, Maharashtra",
    "Kolhapur, Maharashtra",
    "Marine Drive, Maharashtra",
    "Gateway Of India, Mumbai",
    "Sanjay Gandhi National Park, Mumbai",
    "Shree Siddhivinayak, Mumbai",
    "Nariman Point, Mumbai",
    "Dharavi, Mumbai",
    "Chhatrapati Shivaji Terminus, Mumbai",
    "Juhu Beach, Mumbai",
    "Aksa Beach, Mumbai",
    "Nehru Planetarium, Mumbai",
    "Manori Beach, Mumbai",
    "Chowpatty Beach, Mumbai",
    "Haji Ali Mosque, Mumbai",
    "Versova Beach, Mumbai",
  ],
  [
    "Panjim, Goa",
    "Bardez, Goa",
    "Calangute Beach, Goa",
    "Candolim Beach, Goa",
    "Palolem Beach, Goa",
    "Aguada Fort, Goa",
  ],
  [
    "Mysore, Karnataka",
    "Bangalore, Karnataka",
    "Mangalore, Karnataka",
    "Nandi Hills, Karnataka",
    "Murudheshwar, Karnataka",
  ],
  ["Trivandrum, Kerala", "Kovalam, Kerala"],
  [
    "Rameshwaram, Tamil Nadu",
    "Ooty, Tamil Nadu",
    "Chennai, Tamil Nadu",
    "Kanyakumari, Tamil Nadu",
    "Coimbatore, Tamil Nadu",
    "Nilgiri, Tamil Nadu",
    "Kolli Hills, Tamil Nadu",
    "Mahabalipuram, Tamil Nadu",
  ],
  [
    "Vishakhapatnam, Andhra Pradesh",
    "Tirupati, Andhra Pradesh",
    "Kurnool, Andhra Pradesh",
    "Vijayawada, Andhra Pradesh",
  ],
  [
    "Hyderabad, Telangana",
    "Warangal, Telangana",
    "Ananthagiri Hills, Telangana",
  ],
  [
    "Raipur, Chhattisgarh",
    "Indravati National Park, Chhattisgarh",
    "Chitrakote Waterfall, Chhattisgarh",
    "Bilaspur, Chhattisgarh",
  ],
  [
    "Gwalior, Madhya Pradesh",
    "Ujjain, Madhya Pradesh",
    "Indore, Madhya Pradesh",
    "Khajuraho, Madhya Pradesh",
    "Bhopal, Madhya Pradesh",
    "Udayagiri, Madhya Pradesh",
  ],
  [
    "Kolkata, West Bengal",
    "Sunderban, West Bengal",
    "Digha, West Bengal",
    "Malda, West Bengal",
    "Tarapith, West Bengal",
    "GangaSagar, West Bengal",
    "Dargeeling, West Bengal",
    "Siliguri, West Bengal",
  ],
  [
    "Kaziranga, Assam",
    "Guwahati, Assam",
    "Silchar, Assam",
    "Manas National Park, Assam",
    "Kamakhaya Temple, Assam",
  ],
  [
    "Tawang, Arunachal Pradesh",
    "Sela Pass, Arunachal Pradesh",
    "Gorichen Peak, Arunachal Pradesh",
    "Nuranang falls, Arunachal Pradesh",
  ],
  [
    "Kohima, Nagaland",
    "Shilloi Lake, Nagaland",
    "Naga Heritage Village, Nagaland",
  ],

  ["Shillong, Meghalaya", "Cherrapunji, Meghalaya"],

  ["Imphal, Manipur", "Loktak Lake & Sendra Island, Manipur"],
];

export const allLocations = locationsGroup.reduce((prev, current) => [
  ...prev,
  ...current,
]);

export const allLocationOptions = allLocations.map((location) => ({
  label: location,
  value: location,
}));
